class AccordionGallery extends HTMLElement {
  constructor() {
    super();
    this.panels = Array.from(this.querySelectorAll('.ag-panel'));
    this.expandRatio = parseFloat(this.dataset.expandRatio) || 0.55;
    this.activeIndex = Math.min(Math.max(parseInt(this.dataset.defaultIndex, 10) || 0, 0), this.panels.length - 1);
    this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    this.isVerticalClass = this.classList.contains('accordion-gallery--vertical');
    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    this.onResize = this.onResize.bind(this);
    this.measure();
    this.setActive(this.activeIndex);

    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this);

    this.panels.forEach((panel, i) => {
      if (this.hoverCapable) {
        panel.addEventListener('mouseenter', () => this.setActive(i));
      }
      panel.addEventListener('focus', () => {
        if (panel.matches(':focus-visible')) this.setActive(i);
      });
      panel.addEventListener('click', (event) => {
        if (i !== this.activeIndex) {
          event.preventDefault();
          this.setActive(i);
        }
      });
      panel.addEventListener('keydown', (event) => {
        const count = this.panels.length;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          const next = (i + 1) % count;
          this.setActive(next);
          this.panels[next].focus();
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          const prev = (i - 1 + count) % count;
          this.setActive(prev);
          this.panels[prev].focus();
        }
      });
    });
  }

  onResize() {
    this.measure();
  }

  measure() {
    const vertical = this.isVerticalClass || this.mobileQuery.matches;
    const rect = this.getBoundingClientRect();
    const total = vertical ? rect.height : rect.width;
    const gap = parseFloat(getComputedStyle(this).getPropertyValue('--ag-gap')) || 10;
    const usable = Math.max(total - gap * (this.panels.length - 1), 120);
    const size = Math.max(140, usable * this.expandRatio * 1.22);
    this.style.setProperty('--ag-media-size', `${size}px`);
  }

  setActive(index) {
    this.activeIndex = index;
    const r = Math.min(Math.max(this.expandRatio, 0.2), 0.9);
    const count = this.panels.length;
    const grow = count > 1 ? (r * (count - 1)) / (1 - r) : 1;

    this.panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('ag-panel--active', isActive);
      panel.style.flexGrow = isActive ? grow : 1;
      panel.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }
}

customElements.define('accordion-gallery', AccordionGallery);
